// Root store namespace definitions to enable store plugin

export const state = () => ({})

export const mutations = {}

export const actions = {}

export const getters = {}
